import { render, staticRenderFns } from "./bind-teacher.vue?vue&type=template&id=8358e9aa&scoped=true"
import script from "./bind-teacher.vue?vue&type=script&lang=js"
export * from "./bind-teacher.vue?vue&type=script&lang=js"
import style0 from "./bind-teacher.vue?vue&type=style&index=0&id=8358e9aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8358e9aa",
  null
  
)

export default component.exports